import React, { useEffect, useState } from 'react';

import { ReactComponent as ChevronDown } from './../../public/images/chevron-down.svg';
import { ReactComponent as ChevronUp } from './../../public/images/chevron-up.svg';

const TOC = ({ headings, isDefaultUncollapsed = true }) => {

  function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    });

    useEffect(() => {
      function handleResize() {
        setWindowSize({
          windowWidth: window.innerWidth,
        });
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
  }
  const { windowWidth } = useWindowSize();
  const MOBILE_MAX_WIDTH = 768;
  const IS_MOBILE = windowWidth <= MOBILE_MAX_WIDTH;

  const [collapsed, setCollapsed] = useState(true);

  const handleJumpToHeading = (headingText) => {
    const heading = headings.find((heading) => heading.innerText === headingText);
    const isDesktop = windowWidth > MOBILE_MAX_WIDTH;

    if (heading && isDesktop) {
      heading.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else  {
      heading.scrollIntoView({ behavior: 'smooth', block: 'end' });
      setCollapsed(false);
    }
  };

  const handleToggle = () => {
    if (IS_MOBILE) {
      setCollapsed(!collapsed);
    }
  };

  useEffect(() => {
    if (isDefaultUncollapsed) {
      setCollapsed(false);
    }
  }, [isDefaultUncollapsed]);

  return (
    <div className="toc">
      <button type='button' onClick={handleToggle} className="toc__title">
        <strong>In this guide</strong>
        {windowWidth <= MOBILE_MAX_WIDTH && (
          !collapsed ? <ChevronDown /> : <ChevronUp />
        )}
      </button>

      {collapsed && (
        <ul>
          {headings.map((heading, index) => (
            <li key={index}>
              <button type='button' onClick={() => handleJumpToHeading(heading.innerText)}>
                {heading.innerText}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TOC;
